import Spinner from 'react-bootstrap/Spinner'

export const Loader = ({
    type
}) => <>
        {
            type === "textOnly" ?
                <>
                    <div className="custom-loader">Loading...</div>
                </> :
                <>
                    <Spinner animation="border" role="status">
                    </Spinner>
                </>
        }
</>